export default __webpack_public_path__ + "static/media/b13.3912857a.jpg";